import { createFileRoute } from "@tanstack/react-router";

import { CoachingHearth } from "~/components/engagement/coaching-hearth";

import { SharedWheels } from "./-components/shared-wheels";

export const Route = createFileRoute("/_user/coaching/$engagementId/")({
  staticData: { title: "Overview" },
  component: RouteComponent,
});

function RouteComponent() {
  const { engagementId } = Route.useParams();
  return (
    <div className="space-y-6">
      <CoachingHearth engagementId={engagementId} variant="embedded" />
      <SharedWheels engagementId={engagementId} />
    </div>
  );
}
